module.exports = __webpack_public_path__ + "static/media/eth.a79d57db.png";